function sliderInit() {
    const slider = document.querySelector('.swiper-container');
    if (slider && !slider.classList.contains('slider_started')) {
        slider.classList.add('slider_started');
        var swiper = new Swiper('.swiper-container', {
            slidesPerView: 1,
            speed: 250,
            spaceBetween: 0,
            navigation: {
                nextEl: ".product-button-group .swiper-button-next-1",
                prevEl: ".product-button-group .swiper-button-prev-1",
            },
            pagination: {
                el: ".product-card-pagination",
                clickable: true,
            },
        });
    }
}

(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
	}

	document.addEventListener('shopify:section:load', function (e) {
		swiperInit();
	});

	window.addEventListener('resize', function () {
		$('.product-section .js-media-list').each(function () {
			this.swiper.destroy();
		});
		$('.product-section .js-media-sublist').each(function () {
			this.swiper.destroy();
		});

		swiperInit();
	});

	swiperInit();
})();

function subSliderInit() {
    console.log("Sub Slider Initialized");
}
